/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import { addStatusMessage, clearStatusMessage } from '../utilities/status-message';
import { initListeners, initForm } from './product';

function addInputLabel(input, name) {
  if (!input || !name) return;

  input.setAttribute('aria-label', name);
}

export function initQuickAdd() {
  const btn = $('.products--list .products--info .btn');
  if (btn && $.magnificPopup) {
    console.log('initing quick add');
    btn.magnificPopup({
      type: 'ajax',
      callbacks: {
        parseAjax(mfpResponse) {
          console.log('res', mfpResponse);
          if (mfpResponse) {
            mfpResponse.data = `<div class="quick-add"><div class="product__top in--quick-add">${$(
              mfpResponse.data
            )
              .find('.product__top .product__main')
              .html()}</div></div>`;
          }
        },
        ajaxContentAdded() {
          // Ajax content is loaded and appended to DOM
          $('.quick-add .product__info > .from-divider').remove();
          $('.quick-add .product__thumbs').remove();
          $('.quick-add .info').remove();

          // add components
          const productTitle = $('.quick-add .product__title.hide-mobile').text();

          if ($('.quick-add .product__images .product__title').length === 0) {
            $('.quick-add .product__images').prepend(
              `<h2 class="product__title" tabindex="-1">${productTitle}</h2>`
            );
          }

          // more info
          if ($('.quick-add .product__moreinfo').length === 0) {
            $('.mobile-add-form').append(
              `<a href="${this.currItem.src}" class="btn btn--white product__moreinfo">more information</a>`
            );
          }

          // add in the close button
          if ($('.quick-add .inner .close').length === 0) {
            $('.quick-add .inner').prepend('<span class="close"></span>');
          }

          function setSeedVariantSizeOptions(select) {
            const selectedType = $(select).val();
            const options = [];
            $('#variantsseed option').each(() => {
              const [type, option] = $(this).text().split('||');
              if (type === selectedType) {
                // Set value using an object to quote the string (double quotes were breaking this)
                const optionElement = $('<option/>', { value: option });
                optionElement.text(option);
                options.push(optionElement);
              }
            });
            if (options.length > 0) {
              $('#mobile_option_seed_size').html(options);
            }
          }

          setSeedVariantSizeOptions($('#mobile_option_seed'));

          // Add ARIA input labels
          if ($('#mobile_option_seed_size')) {
            addInputLabel($('#mobile_option_seed_size')[0], 'Size');
          }

          if ($('#mobile_option_seed')) {
            addInputLabel($('#mobile_option_seed')[0], 'Option');
          }

          const quickAddModal = this.container[0];

          if (quickAddModal) {
            const quickAddHeading = quickAddModal.querySelector('.product__title');
            quickAddHeading.focus();
          }
          initListeners();
          initForm();
        },
        open() {
          addStatusMessage('Loading quick add form');
        },
        close() {
          clearStatusMessage();
        },
      },
    });
  }

  $('body').on('click', '.quick-add .inner .close', function () {
    if ($.magnificPopup) $.magnificPopup.close();
  });
}

$(document).ready(function () {
  try {
    initQuickAdd();
  } catch (e) {
    console.error(e);
    window.Rollbar.error('quick add js', e);
  }
});
